import React from "react";
import isScript from "../../hooks/isScript";
import { useTranslation } from "react-i18next";

const HelpPage = () => {
  isScript();

  const { t } = useTranslation("help");
  const { t: isLang } = useTranslation("type");

  return (
    <>
      <main className="main help">
        <section className="banner-main">
          <div className="inner">
            <img
              className="logo fade-up"
              src="./assets/logo/logo_bk.png"
              alt="Ready Play Logo"
            />
            <div className="fade-up">
              <span className="tooltip bounce">
                <span className="icon-link"></span>
                {t("banner.toolTip")}
              </span>
              <div className="btn-group">
                <a
                  className="btn-main"
                  href={`./assets/files/ReadyPlay_2.0_App_Manual_${
                    isLang("lang") === "kr" ? "kor" : "eng"
                  }.pdf`}
                  target="_blank"
                >
                  {t("banner.manual")}
                </a>
                <a
                  className="btn-main"
                  href={`./assets/files/ReadyPlay_Virtual_Space_Guide_kor.pdf`}
                  target="_blank"
                >
                  {t("banner.guidance")}
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="qa container">
          <div className="inner">
            <h2 className="main-tit fade-up">{t("faq.mainTit")}</h2>
            <ul className="qa__list fade-up">
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_01")}
                </button>
                <div className="qa__content">
                  <p> {t("faq.ans_01")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_02")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_02")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_03")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_03")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_04")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_04")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_05")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_05")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_06")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_06")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_07")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_07")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_08")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_08")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_09")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_09")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_10")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_10")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_11")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_11")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_12")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_12")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_13")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_13")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_14")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_14")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_15")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_15")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_16")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_16")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_17")}
                </button>
                <div className="qa__content">
                  <p>
                    <a href="mailto:help@readyplay.co.kr?subject=레디플레이 문의 드립니다.">
                      {t("faq.ans_17_f")}
                    </a>
                    &ensp;{t("faq.ans_17_s")}
                  </p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_18")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_18")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_19")}
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_19")}</p>
                </div>
              </li>
              <li>
                <button className="qa__label" type="button">
                  {t("faq.qn_20")}.
                </button>
                <div className="qa__content">
                  <p>{t("faq.ans_20")}</p>
                </div>
              </li>
              {/* <!-- <li>
                            <button className="qa__label" type="button">저희 모임 영상을 촬영하고 싶은데, 어떻게 하나요?</button>
                            <div className="qa__content">
                                <p>스마트폰 화면 녹화 기능을 활용하실 수 있습니다. (삼성폰의 경우 화면 녹화 > 미디어 소리 및 마이크로 설정하시면 됩니다.)</p>
                            </div>
                        </li> --> */}
            </ul>
          </div>
        </section>
      </main>
    </>
  );
};

export default HelpPage;
